module.exports = __webpack_public_path__ + "assets/img/00132.2e2a73f1.png";